import React from "react";

const PdfDownloadButton = ({ btn_name, class_name }) => {
  return (
    <a
      href="/TSPL-Company Profile-V2.0.pdf"
      target="_blank"
      rel="noopener noreferrer"
      className={class_name}
    >
      {btn_name}
    </a>
  );
};

export default PdfDownloadButton;